export const toBoolean = (env?: string, defaultValue = false): boolean => (
  (env ? (/^true$/i).test(env) : defaultValue)
);

export const toNumber = (env?: string, defaultValue: number | undefined = undefined): number | undefined => (
  (env ? Number(env) : defaultValue)
);
